<script setup lang="ts">
defineProps({
    as: { type: String, default: 'div' },
});
</script>

<template>
    <UContainer :as="as">
        <slot />
    </UContainer>
</template>
